import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {RebillingFilters, RebillingGenerateResult, RebillingLine, RebillingNote, RebillingSheets} from '../models/rebilling';

@Injectable({
  providedIn: 'root'
})
export class RebillingService {

  private readonly baseUrl = environment.baseUrlWs + '/api/dad-admin/rebilling';

  constructor(private httpClient: HttpClient) {
  }

  generate(year: number): Observable<RebillingGenerateResult> {
    return this.httpClient.post<RebillingGenerateResult>(this.baseUrl + '/generate', {year});
  }

  getLines(filters: RebillingFilters): Observable<RebillingLine[]> {
    return this.httpClient.get<RebillingLine[]>(this.baseUrl + '/lines', {params: this.toParams(filters)});
  }

  getSheets(filters: RebillingFilters): Observable<RebillingSheets> {
    return this.httpClient.get<RebillingSheets>(this.baseUrl + '/sheets', {params: this.toParams(filters)});
  }

  updateStatus(ids: number[], status: string): Observable<RebillingLine[]> {
    return this.httpClient.put<RebillingLine[]>(this.baseUrl + '/lines/status', {ids, status});
  }

  getNotes(year: number, exchange?: string): Observable<RebillingNote[]> {
    let params = new HttpParams().set('year', year);
    if (exchange) {
      params = params.set('exchange', exchange);
    }
    return this.httpClient.get<RebillingNote[]>(this.baseUrl + '/notes', {params});
  }

  createNote(note: { billingAccount: number; exchange: string; year: number; noteDate: string; text: string }): Observable<RebillingNote> {
    return this.httpClient.post<RebillingNote>(this.baseUrl + '/notes', note);
  }

  updateNote(id: number, note: { billingAccount: number; exchange: string; noteDate: string; text: string }): Observable<RebillingNote> {
    return this.httpClient.put<RebillingNote>(this.baseUrl + '/notes/' + id, note);
  }

  deleteNote(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.baseUrl + '/notes/' + id);
  }

  export(filters: RebillingFilters, groupBy?: string): Observable<ArrayBuffer> {
    let params = this.toParams(filters);
    if (groupBy) {
      params = params.set('groupBy', groupBy);
    }
    return this.httpClient.get(this.baseUrl + '/export', {params, responseType: 'arraybuffer'});
  }

  private toParams(filters: RebillingFilters): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '' && value !== false) {
        params = params.set(key, value === true ? '1' : String(value));
      }
    });
    return params;
  }
}
